"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionObject = exports.PermissionObjectContext = void 0;
var react_1 = require("react");
exports.PermissionObjectContext = (0, react_1.createContext)(null);
function usePermissionObject() {
    var object = (0, react_1.useContext)(exports.PermissionObjectContext);
    if (!object) {
        throw new Error('No PermissionObjectContext found');
    }
    return object;
}
exports.usePermissionObject = usePermissionObject;
